import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  list: {
    margin: theme.spacing(6, 0),
  },

  item: {
    margin: theme.spacing(2, 0),
  },

  itemText: {
    fontWeight: theme.typography.fontWeightRegular,
  },

  itemTitle: {
    fontWeight: theme.typography.fontWeightSemiBold,
    fontSize: theme.typography.body1.fontSize,
  },

  icon: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.extras.green,
    marginRight: theme.spacing(1),
    margin: theme.spacing(2, 0),
  },

  iconWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingRight: theme.spacing(1),
  },
}))
